import { render, staticRenderFns } from "./doc-edit.vue?vue&type=template&id=57f54039"
import script from "./doc-edit.vue?vue&type=script&lang=js"
export * from "./doc-edit.vue?vue&type=script&lang=js"
import style0 from "./doc-edit.vue?vue&type=style&index=0&id=57f54039&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports